// Match the privacy choices shared with the marketing website.
export function analyticsOptOutEnabled(): boolean {
  const nav = navigator as Navigator & { globalPrivacyControl?: boolean };
  return (
    nav.doNotTrack === "1" ||
    (window as Window & { doNotTrack?: string }).doNotTrack === "1" ||
    nav.globalPrivacyControl === true ||
    document.cookie.split("; ").includes("limrun_privacy_optout=1")
  );
}
